<template>
  <div class="footer center-align">
    Deploy10 © 2025
  </div>
</template>

<script>

  export default {
    name: 'Footer',
    components: {  },
    data() {
      return {

      }
    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      }
    },
    methods: {

    }
  }
</script>

<style scoped>

</style>
